import React, { useState, useContext } from "react";
import DataContext from "../../../context/users/DataContextCopy";
import AsconMap, { enShowMap } from "./AsconMap";
import AsconSpotMonitor from "./AsconSpotMonitor";

function AsconMain(props) {
  const { setAsconClickedItem, setRegionId } = useContext(DataContext);
  const [showMapValue, setShowMapValue] = useState(enShowMap.ShowBase);
  const [textview, setTextview] = useState(true);

  const toggleTextview = () => {
    setTextview((prevTextview) => !prevTextview);
  };

  const handleMapPointClick = (pointInfo) => {
    setAsconClickedItem({
      name: pointInfo.name,
    });
  };

  const onSelectClick = (value) => {
    setRegionId(value);
  };

  return (
    <main className="monitoring">
      <AsconMap
        showMapValue={showMapValue}
        setShowMapValue={setShowMapValue}
        textview={textview}
        toggleTextview={toggleTextview}
        onMapPointClick={handleMapPointClick}
      />
      <AsconSpotMonitor />
    </main>
  );
}

export default AsconMain;
